import Building from "./Building/Route";
import Flat from "./Flat/Route";
import UserFlat from "./UserFlat/Route";

export default [...Building, ...Flat, ...UserFlat];
